export const pronvincias_dgi =
    [
  {
    "provincia": "BOCAS DEL TORO",
    "codigo": "1",
    "distritos": [
      {
        "distrito": "BOCAS DEL TORO",
        "codigo": "1-1",
        "corregimientos": [
          {
            "corregimiento": "BOCAS DEL TORO (CABECERA)",
            "codigo": "1-1-1"
          },
          {
            "corregimiento": "BASTIMENTOS",
            "codigo": "1-1-2"
          },
          {
            "corregimiento": "CAUCHERO",
            "codigo": "1-1-3"
          },
          {
            "corregimiento": "PUNTA LAUREL",
            "codigo": "1-1-4"
          },
          {
            "corregimiento": "TIERRA OSCURA",
            "codigo": "1-1-5"
          }
        ]
      },
      {
        "distrito": "CHANGUINOLA",
        "codigo": "1-2",
        "corregimientos": [
          {
            "corregimiento": "CHANGUINOLA (CABECERA)",
            "codigo": "1-2-1"
          },
          {
            "corregimiento": "ALMIRANTE",
            "codigo": "1-2-2"
          },
          {
            "corregimiento": "GUABITO",
            "codigo": "1-2-3"
          },
          {
            "corregimiento": "TERIBE",
            "codigo": "1-2-4"
          },
          {
            "corregimiento": "VALLE DEL RISCO",
            "codigo": "1-2-5"
          },
          {
            "corregimiento": "EL EMPALME",
            "codigo": "1-2-6"
          },
          {
            "corregimiento": "LAS TABLAS",
            "codigo": "1-2-7"
          }
        ]
      },
      {
        "distrito": "CHIRIQUI GRANDE",
        "codigo": "1-3",
        "corregimientos": [
          {
            "corregimiento": "CHIRIQUI GRANDE (CABECERA)",
            "codigo": "1-3-1"
          },
          {
            "corregimiento": "MIRAMAR",
            "codigo": "1-3-2"
          },
          {
            "corregimiento": "PUNTA PEÑA",
            "codigo": "1-3-3"
          },
          {
            "corregimiento": "PUNTA ROBALO",
            "codigo": "1-3-4"
          },
          {
            "corregimiento": "RAMBALA",
            "codigo": "1-3-5"
          }
        ]
      }
    ]
  },
  {
    "provincia": "COCLE",
    "codigo": "2",
    "distritos": [
      {
        "distrito": "AGUADULCE",
        "codigo": "2-1",
        "corregimientos": [
          {
            "corregimiento": "AGUADULCE (CABECERA)",
            "codigo": "2-1-1"
          },
          {
            "corregimiento": "EL CRISTO",
            "codigo": "2-1-2"
          },
          {
            "corregimiento": "EL ROBLE",
            "codigo": "2-1-3"
          },
          {
            "corregimiento": "POCRI",
            "codigo": "2-1-4"
          },
          {
            "corregimiento": "BARRIOS UNIDOS",
            "codigo": "2-1-5"
          }
        ]
      },
      {
        "distrito": "ANTON",
        "codigo": "2-2",
        "corregimientos": [
          {
            "corregimiento": "ANTON (CABECERA)",
            "codigo": "2-2-1"
          },
          {
            "corregimiento": "CABUYA",
            "codigo": "2-2-2"
          },
          {
            "corregimiento": "EL CHIRU",
            "codigo": "2-2-3"
          },
          {
            "corregimiento": "EL RETIRO",
            "codigo": "2-2-4"
          },
          {
            "corregimiento": "EL VALLE",
            "codigo": "2-2-5"
          },
          {
            "corregimiento": "JUAN DIAZ",
            "codigo": "2-2-6"
          },
          {
            "corregimiento": "RIO HATO",
            "codigo": "2-2-7"
          },
          {
            "corregimiento": "SAN JUAN DE DIOS",
            "codigo": "2-2-8"
          },
          {
            "corregimiento": "SANTA RITA",
            "codigo": "2-2-9"
          },
          {
            "corregimiento": "CABALLERO",
            "codigo": "2-2-10"
          }
        ]
      },
      {
        "distrito": "LA PINTADA",
        "codigo": "2-3",
        "corregimientos": [
          {
            "corregimiento": "LA PINTADA (CABECERA)",
            "codigo": "2-3-1"
          },
          {
            "corregimiento": "EL HARINO",
            "codigo": "2-3-2"
          },
          {
            "corregimiento": "EL POTRERO",
            "codigo": "2-3-3"
          },
          {
            "corregimiento": "LLANO GRANDE",
            "codigo": "2-3-4"
          },
          {
            "corregimiento": "PIEDRAS GORDAS",
            "codigo": "2-3-5"
          },
          {
            "corregimiento": "LAS LOMAS",
            "codigo": "2-3-6"
          }
        ]
      },
      {
        "distrito": "NATA",
        "codigo": "2-4",
        "corregimientos": [
          {
            "corregimiento": "NATA (CABECERA)",
            "codigo": "2-4-1"
          },
          {
            "corregimiento": "CAPELLANIA",
            "codigo": "2-4-2"
          },
          {
            "corregimiento": "EL CAÑO",
            "codigo": "2-4-3"
          },
          {
            "corregimiento": "GUZMAN",
            "codigo": "2-4-4"
          },
          {
            "corregimiento": "LAS HUACAS",
            "codigo": "2-4-5"
          },
          {
            "corregimiento": "TOZA",
            "codigo": "2-4-6"
          }
        ]
      },
      {
        "distrito": "OLA",
        "codigo": "2-5",
        "corregimientos": [
          {
            "corregimiento": "OLA (CABECERA)",
            "codigo": "2-5-1"
          },
          {
            "corregimiento": "EL COPE",
            "codigo": "2-5-2"
          },
          {
            "corregimiento": "EL PALMAR",
            "codigo": "2-5-3"
          },
          {
            "corregimiento": "EL PICACHO",
            "codigo": "2-5-4"
          },
          {
            "corregimiento": "LA PAVA",
            "codigo": "2-5-5"
          }
        ]
      },
      {
        "distrito": "PENONOME",
        "codigo": "2-6",
        "corregimientos": [
          {
            "corregimiento": "PENONOME (CABECERA)",
            "codigo": "2-6-1"
          },
          {
            "corregimiento": "CAÑAVERAL",
            "codigo": "2-6-2"
          },
          {
            "corregimiento": "COCLE",
            "codigo": "2-6-3"
          },
          {
            "corregimiento": "CHIGUIRI ARRIBA",
            "codigo": "2-6-4"
          },
          {
            "corregimiento": "EL COCO",
            "codigo": "2-6-5"
          },
          {
            "corregimiento": "PAJONAL",
            "codigo": "2-6-6"
          },
          {
            "corregimiento": "RIO GRANDE",
            "codigo": "2-6-7"
          },
          {
            "corregimiento": "RIO INDIO",
            "codigo": "2-6-8"
          },
          {
            "corregimiento": "TOABRE",
            "codigo": "2-6-9"
          },
          {
            "corregimiento": "TULU",
            "codigo": "2-6-10"
          }
        ]
      }
    ]
  },
  {
    "provincia": "COLON",
    "codigo": "3",
    "distritos": [
      {
        "distrito": "COLON",
        "codigo": "3-1",
        "corregimientos": [
          {
            "corregimiento": "BARRIO NORTE",
            "codigo": "3-1-1"
          },
          {
            "corregimiento": "BARRIO SUR",
            "codigo": "3-1-2"
          },
          {
            "corregimiento": "BUENA VISTA",
            "codigo": "3-1-3"
          },
          {
            "corregimiento": "CATIVA",
            "codigo": "3-1-4"
          },
          {
            "corregimiento": "CIRICITO",
            "codigo": "3-1-5"
          },
          {
            "corregimiento": "CRISTOBAL",
            "codigo": "3-1-6"
          },
          {
            "corregimiento": "ESCOBAL",
            "codigo": "3-1-7"
          },
          {
            "corregimiento": "LIMON",
            "codigo": "3-1-8"
          },
          {
            "corregimiento": "NUEVA PROVIDENCIA",
            "codigo": "3-1-9"
          },
          {
            "corregimiento": "PUERTO PILON",
            "codigo": "3-1-10"
          },
          {
            "corregimiento": "SABANITAS",
            "codigo": "3-1-11"
          },
          {
            "corregimiento": "SALAMANCA",
            "codigo": "3-1-12"
          },
          {
            "corregimiento": "SAN JUAN",
            "codigo": "3-1-13"
          },
          {
            "corregimiento": "SANTA ROSA",
            "codigo": "3-1-14"
          }
        ]
      },
      {
        "distrito": "CHAGRES",
        "codigo": "3-2",
        "corregimientos": [
          {
            "corregimiento": "NUEVO CHAGRES (CABECERA)",
            "codigo": "3-2-1"
          },
          {
            "corregimiento": "ACHIOTE",
            "codigo": "3-2-2"
          },
          {
            "corregimiento": "EL GUABO",
            "codigo": "3-2-3"
          },
          {
            "corregimiento": "LA ENCANTADA",
            "codigo": "3-2-4"
          },
          {
            "corregimiento": "PALMAS BELLAS",
            "codigo": "3-2-5"
          },
          {
            "corregimiento": "PIÑA",
            "codigo": "3-2-6"
          },
          {
            "corregimiento": "SALUD",
            "codigo": "3-2-7"
          }
        ]
      },
      {
        "distrito": "DONOSO",
        "codigo": "3-3",
        "corregimientos": [
          {
            "corregimiento": "MIGUEL DE LA BORDA (CABECERA)",
            "codigo": "3-3-1"
          },
          {
            "corregimiento": "COCLE DEL NORTE",
            "codigo": "3-3-2"
          },
          {
            "corregimiento": "EL GUASIMO",
            "codigo": "3-3-3"
          },
          {
            "corregimiento": "GOBEA",
            "codigo": "3-3-4"
          },
          {
            "corregimiento": "RIO INDIO",
            "codigo": "3-3-5"
          },
          {
            "corregimiento": "SAN JOSE DEL GENERAL",
            "codigo": "3-3-6"
          }
        ]
      },
      {
        "distrito": "PORTOBELO",
        "codigo": "3-4",
        "corregimientos": [
          {
            "corregimiento": "PORTOBELO (CABECERA)",
            "codigo": "3-4-1"
          },
          {
            "corregimiento": "CACIQUE",
            "codigo": "3-4-2"
          },
          {
            "corregimiento": "GARROTE",
            "codigo": "3-4-3"
          },
          {
            "corregimiento": "ISLA GRANDE",
            "codigo": "3-4-4"
          },
          {
            "corregimiento": "MARIA CHIQUITA",
            "codigo": "3-4-5"
          }
        ]
      },
      {
        "distrito": "SANTA ISABEL",
        "codigo": "3-5",
        "corregimientos": [
          {
            "corregimiento": "PALENQUE (CABECERA)",
            "codigo": "3-5-1"
          },
          {
            "corregimiento": "CUANGO",
            "codigo": "3-5-2"
          },
          {
            "corregimiento": "MIRAMAR",
            "codigo": "3-5-3"
          },
          {
            "corregimiento": "NOMBRE DE DIOS",
            "codigo": "3-5-4"
          },
          {
            "corregimiento": "PALMIRA",
            "codigo": "3-5-5"
          },
          {
            "corregimiento": "PLAYA CHIQUITA",
            "codigo": "3-5-6"
          },
          {
            "corregimiento": "SANTA ISABEL",
            "codigo": "3-5-7"
          },
          {
            "corregimiento": "VIENTO FRIO",
            "codigo": "3-5-8"
          }
        ]
      }
    ]
  },
  {
    "provincia": "CHIRIQUI",
    "codigo": "4",
    "distritos": [
      {
        "distrito": "ALANJE",
        "codigo": "4-1",
        "corregimientos": [
          {
            "corregimiento": "ALANJE (CABECERA)",
            "codigo": "4-1-1"
          },
          {
            "corregimiento": "DIVALA",
            "codigo": "4-1-2"
          },
          {
            "corregimiento": "EL TEJAR",
            "codigo": "4-1-3"
          },
          {
            "corregimiento": "GUARUMAL",
            "codigo": "4-1-4"
          },
          {
            "corregimiento": "PALO GRANDE",
            "codigo": "4-1-5"
          },
          {
            "corregimiento": "QUEREVALO",
            "codigo": "4-1-6"
          },
          {
            "corregimiento": "SANTO TOMAS",
            "codigo": "4-1-7"
          },
          {
            "corregimiento": "CANTA GALLO",
            "codigo": "4-1-8"
          },
          {
            "corregimiento": "NUEVO MEXICO",
            "codigo": "4-1-9"
          }
        ]
      },
      {
        "distrito": "BARU",
        "codigo": "4-2",
        "corregimientos": [
          {
            "corregimiento": "PUERTO ARMUELLES (CABECERA)",
            "codigo": "4-2-1"
          },
          {
            "corregimiento": "LIMONES",
            "codigo": "4-2-2"
          },
          {
            "corregimiento": "PROGRESO",
            "codigo": "4-2-3"
          },
          {
            "corregimiento": "BACO",
            "codigo": "4-2-4"
          },
          {
            "corregimiento": "RODOLFO AGUILAR DELGADO",
            "codigo": "4-2-5"
          }
        ]
      },
      {
        "distrito": "BOQUERON",
        "codigo": "4-3",
        "corregimientos": [
          {
            "corregimiento": "BOQUERON (CABECERA)",
            "codigo": "4-3-1"
          },
          {
            "corregimiento": "BAGALA",
            "codigo": "4-3-2"
          },
          {
            "corregimiento": "CORDILLERA",
            "codigo": "4-3-3"
          },
          {
            "corregimiento": "GUABAL",
            "codigo": "4-3-4"
          },
          {
            "corregimiento": "GUAYABAL",
            "codigo": "4-3-5"
          },
          {
            "corregimiento": "PARAISO",
            "codigo": "4-3-6"
          },
          {
            "corregimiento": "PEDREGAL",
            "codigo": "4-3-7"
          },
          {
            "corregimiento": "TIJERAS",
            "codigo": "4-3-8"
          }
        ]
      },
      {
        "distrito": "BOQUETE",
        "codigo": "4-4",
        "corregimientos": [
          {
            "corregimiento": "BAJO BOQUETE (CABECERA)",
            "codigo": "4-4-1"
          },
          {
            "corregimiento": "CALDERA",
            "codigo": "4-4-2"
          },
          {
            "corregimiento": "PALMIRA",
            "codigo": "4-4-3"
          },
          {
            "corregimiento": "ALTO BOQUETE",
            "codigo": "4-4-4"
          },
          {
            "corregimiento": "JARAMILLO",
            "codigo": "4-4-5"
          },
          {
            "corregimiento": "LOS NARANJOS",
            "codigo": "4-4-6"
          }
        ]
      },
      {
        "distrito": "BUGABA",
        "codigo": "4-5",
        "corregimientos": [
          {
            "corregimiento": "LA CONCEPCION (CABECERA)",
            "codigo": "4-5-1"
          },
          {
            "corregimiento": "ASERRIO DE GARICHE",
            "codigo": "4-5-2"
          },
          {
            "corregimiento": "BUGABA",
            "codigo": "4-5-3"
          },
          {
            "corregimiento": "CERRO PUNTA",
            "codigo": "4-5-4"
          },
          {
            "corregimiento": "GOMEZ",
            "codigo": "4-5-5"
          },
          {
            "corregimiento": "LA ESTRELLA",
            "codigo": "4-5-6"
          },
          {
            "corregimiento": "SAN ANDRES",
            "codigo": "4-5-7"
          },
          {
            "corregimiento": "SANTA MARTA",
            "codigo": "4-5-8"
          },
          {
            "corregimiento": "SANTA ROSA",
            "codigo": "4-5-9"
          },
          {
            "corregimiento": "SANTO DOMINGO",
            "codigo": "4-5-10"
          },
          {
            "corregimiento": "SORTOVA",
            "codigo": "4-5-11"
          },
          {
            "corregimiento": "VOLCAN",
            "codigo": "4-5-12"
          },
          {
            "corregimiento": "EL BONGO",
            "codigo": "4-5-13"
          }
        ]
      },
      {
        "distrito": "DAVID",
        "codigo": "4-6",
        "corregimientos": [
          {
            "corregimiento": "DAVID (CABECERA)",
            "codigo": "4-6-1"
          },
          {
            "corregimiento": "BIJAGUAL",
            "codigo": "4-6-2"
          },
          {
            "corregimiento": "COCHEA",
            "codigo": "4-6-3"
          },
          {
            "corregimiento": "CHIRIQUI",
            "codigo": "4-6-4"
          },
          {
            "corregimiento": "GUACA",
            "codigo": "4-6-5"
          },
          {
            "corregimiento": "LAS LOMAS",
            "codigo": "4-6-6"
          },
          {
            "corregimiento": "PEDREGAL",
            "codigo": "4-6-7"
          },
          {
            "corregimiento": "SAN CARLOS",
            "codigo": "4-6-8"
          },
          {
            "corregimiento": "SAN PABLO NUEVO",
            "codigo": "4-6-9"
          },
          {
            "corregimiento": "SAN PABLO VIEJO",
            "codigo": "4-6-10"
          }
        ]
      },
      {
        "distrito": "DOLEGA",
        "codigo": "4-7",
        "corregimientos": [
          {
            "corregimiento": "DOLEGA (CABECERA)",
            "codigo": "4-7-1"
          },
          {
            "corregimiento": "DOS RIOS",
            "codigo": "4-7-2"
          },
          {
            "corregimiento": "LOS ANASTACIOS",
            "codigo": "4-7-3"
          },
          {
            "corregimiento": "POTRERILLOS",
            "codigo": "4-7-4"
          },
          {
            "corregimiento": "POTRERILLOS ABAJO",
            "codigo": "4-7-5"
          },
          {
            "corregimiento": "ROVIRA",
            "codigo": "4-7-6"
          },
          {
            "corregimiento": "TINAJAS",
            "codigo": "4-7-7"
          },
          {
            "corregimiento": "LOS ALGARRROBOS",
            "codigo": "4-7-8"
          }
        ]
      },
      {
        "distrito": "GUALACA",
        "codigo": "4-8",
        "corregimientos": [
          {
            "corregimiento": "GUALACA (CABECERA)",
            "codigo": "4-8-1"
          },
          {
            "corregimiento": "HORNITO",
            "codigo": "4-8-2"
          },
          {
            "corregimiento": "LOS ANGELES",
            "codigo": "4-8-3"
          },
          {
            "corregimiento": "PAJA DE SOMBRERO",
            "codigo": "4-8-4"
          },
          {
            "corregimiento": "RINCON",
            "codigo": "4-8-5"
          }
        ]
      },
      {
        "distrito": "REMEDIOS",
        "codigo": "4-9",
        "corregimientos": [
          {
            "corregimiento": "REMEDIOS (CABECERA)",
            "codigo": "4-9-1"
          },
          {
            "corregimiento": "EL NANCITO",
            "codigo": "4-9-2"
          },
          {
            "corregimiento": "EL PORVENIR",
            "codigo": "4-9-3"
          },
          {
            "corregimiento": "EL PUERTO",
            "codigo": "4-9-4"
          },
          {
            "corregimiento": "SANTA LUCIA",
            "codigo": "4-9-5"
          }
        ]
      },
      {
        "distrito": "RENACIMIENTO",
        "codigo": "4-10",
        "corregimientos": [
          {
            "corregimiento": "RIO SERENO (CABECERA)",
            "codigo": "4-10-1"
          },
          {
            "corregimiento": "BREÑON",
            "codigo": "4-10-2"
          },
          {
            "corregimiento": "CAÑAS GORDAS",
            "codigo": "4-10-3"
          },
          {
            "corregimiento": "MONTE LIRIO",
            "codigo": "4-10-4"
          },
          {
            "corregimiento": "PLAZA CAISAN",
            "codigo": "4-10-5"
          },
          {
            "corregimiento": "SANTA CRUZ",
            "codigo": "4-10-6"
          },
          {
            "corregimiento": "DOMINICAL",
            "codigo": "4-10-7"
          },
          {
            "corregimiento": "SANTA CLARA",
            "codigo": "4-10-8"
          }
        ]
      },
      {
        "distrito": "SAN FELIX",
        "codigo": "4-11",
        "corregimientos": [
          {
            "corregimiento": "LAS LAJAS (CABECERA)",
            "codigo": "4-11-1"
          },
          {
            "corregimiento": "JUAY",
            "codigo": "4-11-2"
          },
          {
            "corregimiento": "LAJAS ADENTRO",
            "codigo": "4-11-3"
          },
          {
            "corregimiento": "SAN FELIX",
            "codigo": "4-11-4"
          },
          {
            "corregimiento": "SANTA CRUZ",
            "codigo": "4-11-5"
          }
        ]
      },
      {
        "distrito": "SAN LORENZO",
        "codigo": "4-12",
        "corregimientos": [
          {
            "corregimiento": "HORCONCITOS (CABECERA)",
            "codigo": "4-12-1"
          },
          {
            "corregimiento": "BOCA CHICA",
            "codigo": "4-12-2"
          },
          {
            "corregimiento": "BOCA DEL MONTE",
            "codigo": "4-12-3"
          },
          {
            "corregimiento": "SAN JUAN",
            "codigo": "4-12-4"
          },
          {
            "corregimiento": "SAN LORENZO",
            "codigo": "4-12-5"
          }
        ]
      },
      {
        "distrito": "TOLE",
        "codigo": "4-13",
        "corregimientos": [
          {
            "corregimiento": "TOLE (CABECERA)",
            "codigo": "4-13-1"
          },
          {
            "corregimiento": "BELLA VISTA",
            "codigo": "4-13-2"
          },
          {
            "corregimiento": "CERRO VIEJO",
            "codigo": "4-13-3"
          },
          {
            "corregimiento": "EL CRISTO",
            "codigo": "4-13-4"
          },
          {
            "corregimiento": "JUSTO FIDEL PALACIOS",
            "codigo": "4-13-5"
          },
          {
            "corregimiento": "LAJAS DE TOLE",
            "codigo": "4-13-6"
          },
          {
            "corregimiento": "POTRERO DE CAÑA",
            "codigo": "4-13-7"
          },
          {
            "corregimiento": "QUEBRADA DE PIEDRA",
            "codigo": "4-13-8"
          },
          {
            "corregimiento": "VELADERO",
            "codigo": "4-13-9"
          }
        ]
      },

      {
        "distrito": "TIERRAS ALTAS",
        "codigo": "4-13",
        "corregimientos": [
          {
            "corregimiento": "Volcán",
            "codigo": "4-14-1"
          },
          {
            "corregimiento": "Cerro Punta",
            "codigo": "4-14-2"
          },
          {
            "corregimiento": "Cuesta de Piedra",
            "codigo": "4-14-3"
          },
          {
            "corregimiento": "Nueva California",
            "codigo": "4-14-4"
          },
          {
            "corregimiento": "Paso Ancho",
            "codigo": "4-14-5"
          }
        ]
      },
    ]
  },
  {
    "provincia": "DARIEN",
    "codigo": "5",
    "distritos": [
      {
        "distrito": "CHEPIGANA",
        "codigo": "5-1",
        "corregimientos": [
          {
            "corregimiento": "LA PALMA (CABECERA)",
            "codigo": "5-1-1"
          },
          {
            "corregimiento": "CAMOGANTI",
            "codigo": "5-1-2"
          },
          {
            "corregimiento": "CHEPIGANA",
            "codigo": "5-1-3"
          },
          {
            "corregimiento": "GARACHINE",
            "codigo": "5-1-4"
          },
          {
            "corregimiento": "JAQUE",
            "codigo": "5-1-5"
          },
          {
            "corregimiento": "PUERTO PIÑA",
            "codigo": "5-1-6"
          },
          {
            "corregimiento": "RIO CONGO",
            "codigo": "5-1-7"
          },
          {
            "corregimiento": "RIO IGLESIAS",
            "codigo": "5-1-8"
          },
          {
            "corregimiento": "SAMBU",
            "codigo": "5-1-9"
          },
          {
            "corregimiento": "SETEGANTI",
            "codigo": "5-1-10"
          },
          {
            "corregimiento": "TAIMATI",
            "codigo": "5-1-11"
          },
          {
            "corregimiento": "TUCUTI",
            "codigo": "5-1-12"
          },
          {
            "corregimiento": "AGUA FRIA",
            "codigo": "5-1-13"
          },
          {
            "corregimiento": "CUCUNATI",
            "codigo": "5-1-14"
          },
          {
            "corregimiento": "RIO CONGO ARRIBA",
            "codigo": "5-1-15"
          },
          {
            "corregimiento": "SANTA FE",
            "codigo": "5-1-16"
          }
        ]
      },
      {
        "distrito": "PINOGANA",
        "codigo": "5-2",
        "corregimientos": [
          {
            "corregimiento": "EL REAL DE SANTA MARIA (CABECE",
            "codigo": "5-2-1"
          },
          {
            "corregimiento": "BOCA DE CUPE",
            "codigo": "5-2-2"
          },
          {
            "corregimiento": "PAYA",
            "codigo": "5-2-3"
          },
          {
            "corregimiento": "PINOGANA",
            "codigo": "5-2-4"
          },
          {
            "corregimiento": "PUCURO",
            "codigo": "5-2-5"
          },
          {
            "corregimiento": "YAPE",
            "codigo": "5-2-6"
          },
          {
            "corregimiento": "YAVIZA",
            "codigo": "5-2-7"
          },
          {
            "corregimiento": "METETI",
            "codigo": "5-2-8"
          },
          {
            "corregimiento": "COMARCA KUNA DE WARGANDI",
            "codigo": "5-2-9"
          }
        ]
      }
    ]
  },
  {
    "provincia": "HERRERA",
    "codigo": "6",
    "distritos": [
      {
        "distrito": "CHITRE",
        "codigo": "6-1",
        "corregimientos": [
          {
            "corregimiento": "CHITRE (CABECERA)",
            "codigo": "6-1-1"
          },
          {
            "corregimiento": "LA ARENA",
            "codigo": "6-1-2"
          },
          {
            "corregimiento": "MONAGRILLO",
            "codigo": "6-1-3"
          },
          {
            "corregimiento": "LLANO BONITO",
            "codigo": "6-1-4"
          },
          {
            "corregimiento": "SAN JUAN BAUTISTA",
            "codigo": "6-1-5"
          }
        ]
      },
      {
        "distrito": "LAS MINAS",
        "codigo": "6-2",
        "corregimientos": [
          {
            "corregimiento": "LAS MINAS (CABECERA)",
            "codigo": "6-2-1"
          },
          {
            "corregimiento": "CHEPO",
            "codigo": "6-2-2"
          },
          {
            "corregimiento": "CHUMICAL",
            "codigo": "6-2-3"
          },
          {
            "corregimiento": "EL TORO",
            "codigo": "6-2-4"
          },
          {
            "corregimiento": "LEONES",
            "codigo": "6-2-5"
          },
          {
            "corregimiento": "QUEBRADA DEL ROSARIO",
            "codigo": "6-2-6"
          },
          {
            "corregimiento": "QUEBRADA EL CIPRIAN",
            "codigo": "6-2-7"
          }
        ]
      },
      {
        "distrito": "LOS POZOS",
        "codigo": "6-3",
        "corregimientos": [
          {
            "corregimiento": "LOS POZOS (CABECERA)",
            "codigo": "6-3-1"
          },
          {
            "corregimiento": "CAPURI",
            "codigo": "6-3-2"
          },
          {
            "corregimiento": "EL CALABACITO",
            "codigo": "6-3-3"
          },
          {
            "corregimiento": "EL CEDRO",
            "codigo": "6-3-4"
          },
          {
            "corregimiento": "LA ARENA",
            "codigo": "6-3-5"
          },
          {
            "corregimiento": "LA PITALOSA",
            "codigo": "6-3-6"
          },
          {
            "corregimiento": "LOS CERRITOS",
            "codigo": "6-3-7"
          },
          {
            "corregimiento": "LOS CERROS DE PAJA",
            "codigo": "6-3-8"
          },
          {
            "corregimiento": "LAS LLANAS",
            "codigo": "6-3-9"
          }
        ]
      },
      {
        "distrito": "OCU",
        "codigo": "6-4",
        "corregimientos": [
          {
            "corregimiento": "OCU (CABECERA)",
            "codigo": "6-4-1"
          },
          {
            "corregimiento": "CERRO LARGO",
            "codigo": "6-4-2"
          },
          {
            "corregimiento": "LOS LLANOS",
            "codigo": "6-4-3"
          },
          {
            "corregimiento": "LLANO GRANDE",
            "codigo": "6-4-4"
          },
          {
            "corregimiento": "PEÑAS CHATAS",
            "codigo": "6-4-5"
          },
          {
            "corregimiento": "EL TIJERA",
            "codigo": "6-4-6"
          },
          {
            "corregimiento": "MENCHACA",
            "codigo": "6-4-7"
          }
        ]
      },
      {
        "distrito": "PARITA",
        "codigo": "6-5",
        "corregimientos": [
          {
            "corregimiento": "PARITA (CABECERA)",
            "codigo": "6-5-1"
          },
          {
            "corregimiento": "CABUYA",
            "codigo": "6-5-2"
          },
          {
            "corregimiento": "LOS CASTILLOS",
            "codigo": "6-5-3"
          },
          {
            "corregimiento": "LLANO DE LA CRUZ",
            "codigo": "6-5-4"
          },
          {
            "corregimiento": "PARIS",
            "codigo": "6-5-5"
          },
          {
            "corregimiento": "PORTOBELILLO",
            "codigo": "6-5-6"
          },
          {
            "corregimiento": "POTUGA",
            "codigo": "6-5-7"
          }
        ]
      },
      {
        "distrito": "PESE",
        "codigo": "6-6",
        "corregimientos": [
          {
            "corregimiento": "PESE (CABECERA)",
            "codigo": "6-6-1"
          },
          {
            "corregimiento": "LAS CABRAS",
            "codigo": "6-6-2"
          },
          {
            "corregimiento": "EL PAJARO",
            "codigo": "6-6-3"
          },
          {
            "corregimiento": "EL BARRERO",
            "codigo": "6-6-4"
          },
          {
            "corregimiento": "EL PEDREGOSO",
            "codigo": "6-6-5"
          },
          {
            "corregimiento": "EL CIRUELO",
            "codigo": "6-6-6"
          },
          {
            "corregimiento": "SABANAGRANDE",
            "codigo": "6-6-7"
          },
          {
            "corregimiento": "RINCON HONDO",
            "codigo": "6-6-8"
          }
        ]
      },
      {
        "distrito": "SANTA MARIA",
        "codigo": "6-7",
        "corregimientos": [
          {
            "corregimiento": "SANTA MARIA (CABECERA)",
            "codigo": "6-7-1"
          },
          {
            "corregimiento": "CHUPAMPA",
            "codigo": "6-7-2"
          },
          {
            "corregimiento": "EL RINCON",
            "codigo": "6-7-3"
          },
          {
            "corregimiento": "EL LIMON",
            "codigo": "6-7-4"
          },
          {
            "corregimiento": "LOS CANELOS",
            "codigo": "6-7-5"
          }
        ]
      }
    ]
  },
  {
    "provincia": "LOS SANTOS",
    "codigo": "7",
    "distritos": [
      {
        "distrito": "GUARARE",
        "codigo": "7-1",
        "corregimientos": [
          {
            "corregimiento": "GUARARE (CABECERA)",
            "codigo": "7-1-1"
          },
          {
            "corregimiento": "EL ESPINAL",
            "codigo": "7-1-2"
          },
          {
            "corregimiento": "EL MACANO",
            "codigo": "7-1-3"
          },
          {
            "corregimiento": "GUARARE ARRIBA",
            "codigo": "7-1-4"
          },
          {
            "corregimiento": "LA ENEA",
            "codigo": "7-1-5"
          },
          {
            "corregimiento": "LA PASERA",
            "codigo": "7-1-6"
          },
          {
            "corregimiento": "LAS TRANCAS",
            "codigo": "7-1-7"
          },
          {
            "corregimiento": "LLANO ABAJO",
            "codigo": "7-1-8"
          },
          {
            "corregimiento": "EL HATO",
            "codigo": "7-1-9"
          },
          {
            "corregimiento": "PERALES",
            "codigo": "7-1-10"
          }
        ]
      },
      {
        "distrito": "LAS TABLAS",
        "codigo": "7-2",
        "corregimientos": [
          {
            "corregimiento": "LAS TABLAS (CABECERA)",
            "codigo": "7-2-1"
          },
          {
            "corregimiento": "BAJO CORRAL",
            "codigo": "7-2-2"
          },
          {
            "corregimiento": "BAYANO",
            "codigo": "7-2-3"
          },
          {
            "corregimiento": "EL CARATE",
            "codigo": "7-2-4"
          },
          {
            "corregimiento": "EL COCAL",
            "codigo": "7-2-5"
          },
          {
            "corregimiento": "EL MANANTIAL",
            "codigo": "7-2-6"
          },
          {
            "corregimiento": "EL MUÑOZ",
            "codigo": "7-2-7"
          },
          {
            "corregimiento": "EL PEDREGOSO",
            "codigo": "7-2-8"
          },
          {
            "corregimiento": "LA LAJA",
            "codigo": "7-2-9"
          },
          {
            "corregimiento": "LA MIEL",
            "codigo": "7-2-10"
          },
          {
            "corregimiento": "LA PALMA",
            "codigo": "7-2-11"
          },
          {
            "corregimiento": "LA TIZA",
            "codigo": "7-2-12"
          },
          {
            "corregimiento": "LAS PALMITAS",
            "codigo": "7-2-13"
          },
          {
            "corregimiento": "LAS TABLAS ABAJO",
            "codigo": "7-2-14"
          },
          {
            "corregimiento": "NUARIO",
            "codigo": "7-2-15"
          },
          {
            "corregimiento": "PALMIRA",
            "codigo": "7-2-16"
          },
          {
            "corregimiento": "PEÑA BLANCA",
            "codigo": "7-2-17"
          },
          {
            "corregimiento": "RIO HONDO",
            "codigo": "7-2-18"
          },
          {
            "corregimiento": "SAN JOSE",
            "codigo": "7-2-19"
          },
          {
            "corregimiento": "SAN MIGUEL",
            "codigo": "7-2-20"
          },
          {
            "corregimiento": "SANTO DOMINGO",
            "codigo": "7-2-21"
          },
          {
            "corregimiento": "SESTEADERO",
            "codigo": "7-2-22"
          },
          {
            "corregimiento": "VALLE RICO",
            "codigo": "7-2-23"
          },
          {
            "corregimiento": "VALLERIQUITO",
            "codigo": "7-2-24"
          }
        ]
      },
      {
        "distrito": "LOS SANTOS",
        "codigo": "7-3",
        "corregimientos": [
          {
            "corregimiento": "LA VILLA DE LOS SANTOS (CABECE",
            "codigo": "7-3-1"
          },
          {
            "corregimiento": "EL GUASIMO",
            "codigo": "7-3-2"
          },
          {
            "corregimiento": "LA COLORADA",
            "codigo": "7-3-3"
          },
          {
            "corregimiento": "LA ESPIGADILLA",
            "codigo": "7-3-4"
          },
          {
            "corregimiento": "LAS CRUCES",
            "codigo": "7-3-5"
          },
          {
            "corregimiento": "LAS GUABAS",
            "codigo": "7-3-6"
          },
          {
            "corregimiento": "LOS ANGELES",
            "codigo": "7-3-7"
          },
          {
            "corregimiento": "LOS OLIVOS",
            "codigo": "7-3-8"
          },
          {
            "corregimiento": "LLANO LARGO",
            "codigo": "7-3-9"
          },
          {
            "corregimiento": "SABANAGRANDE",
            "codigo": "7-3-10"
          },
          {
            "corregimiento": "SANTA ANA",
            "codigo": "7-3-11"
          },
          {
            "corregimiento": "TRES QUEBRADAS",
            "codigo": "7-3-12"
          },
          {
            "corregimiento": "AGUA BUENA",
            "codigo": "7-3-13"
          },
          {
            "corregimiento": "VILLA LOURDES",
            "codigo": "7-3-14"
          }
        ]
      },
      {
        "distrito": "MACARACAS",
        "codigo": "7-4",
        "corregimientos": [
          {
            "corregimiento": "MACARACAS (CABECERA)",
            "codigo": "7-4-1"
          },
          {
            "corregimiento": "BAHIA HONDA",
            "codigo": "7-4-2"
          },
          {
            "corregimiento": "BAJOS DE GUERA",
            "codigo": "7-4-3"
          },
          {
            "corregimiento": "COROZAL",
            "codigo": "7-4-4"
          },
          {
            "corregimiento": "CHUPA",
            "codigo": "7-4-5"
          },
          {
            "corregimiento": "EL CEDRO",
            "codigo": "7-4-6"
          },
          {
            "corregimiento": "ESPINO AMARILLO",
            "codigo": "7-4-7"
          },
          {
            "corregimiento": "LA MESA",
            "codigo": "7-4-8"
          },
          {
            "corregimiento": "LAS PALMAS",
            "codigo": "7-4-9"
          },
          {
            "corregimiento": "LLANO DE PIEDRA",
            "codigo": "7-4-10"
          },
          {
            "corregimiento": "MOGOLLON",
            "codigo": "7-4-11"
          }
        ]
      },
      {
        "distrito": "PEDASI",
        "codigo": "7-5",
        "corregimientos": [
          {
            "corregimiento": "PEDASI (CABECERA)",
            "codigo": "7-5-1"
          },
          {
            "corregimiento": "LOS ASIENTOS",
            "codigo": "7-5-2"
          },
          {
            "corregimiento": "MARIABE",
            "codigo": "7-5-3"
          },
          {
            "corregimiento": "PURIO",
            "codigo": "7-5-4"
          },
          {
            "corregimiento": "ORIA ARRIBA",
            "codigo": "7-5-5"
          }
        ]
      },
      {
        "distrito": "POCRI",
        "codigo": "7-6",
        "corregimientos": [
          {
            "corregimiento": "POCRI",
            "codigo": "7-6-1"
          },
          {
            "corregimiento": "EL CAÑAFISTULO",
            "codigo": "7-6-2"
          },
          {
            "corregimiento": "LAJAMINA",
            "codigo": "7-6-3"
          },
          {
            "corregimiento": "PARAISO",
            "codigo": "7-6-4"
          },
          {
            "corregimiento": "PARITILLA",
            "codigo": "7-6-5"
          }
        ]
      },
      {
        "distrito": "TONOSI",
        "codigo": "7-7",
        "corregimientos": [
          {
            "corregimiento": "TONOSI (CABECERA)",
            "codigo": "7-7-1"
          },
          {
            "corregimiento": "ALTOS DE GUERA",
            "codigo": "7-7-2"
          },
          {
            "corregimiento": "CAÑAS",
            "codigo": "7-7-3"
          },
          {
            "corregimiento": "EL BEBEDERO",
            "codigo": "7-7-4"
          },
          {
            "corregimiento": "EL CACAO",
            "codigo": "7-7-5"
          },
          {
            "corregimiento": "EL CORTEZO",
            "codigo": "7-7-6"
          },
          {
            "corregimiento": "FLORES",
            "codigo": "7-7-7"
          },
          {
            "corregimiento": "GUANICO",
            "codigo": "7-7-8"
          },
          {
            "corregimiento": "LA TRONOSA",
            "codigo": "7-7-9"
          },
          {
            "corregimiento": "CAMBUTAL",
            "codigo": "7-7-10"
          },
          {
            "corregimiento": "ISLA DE CAQAS",
            "codigo": "7-7-11"
          }
        ]
      }
    ]
  },
  {
    "provincia": "PANAMA",
    "codigo": "8",
    "distritos": [
      {
        "distrito": "BALBOA",
        "codigo": "8-2",
        "corregimientos": [
          {
            "corregimiento": "SAN MIGUEL (CABECERA)",
            "codigo": "8-2-1"
          },
          {
            "corregimiento": "LA ENSENADA",
            "codigo": "8-2-2"
          },
          {
            "corregimiento": "LA ESMERALDA",
            "codigo": "8-2-3"
          },
          {
            "corregimiento": "LA GUINEA",
            "codigo": "8-2-4"
          },
          {
            "corregimiento": "PEDRO GONZALEZ",
            "codigo": "8-2-5"
          },
          {
            "corregimiento": "SABOGA",
            "codigo": "8-2-6"
          }
        ]
      },
      {
        "distrito": "CHEPO",
        "codigo": "8-5",
        "corregimientos": [
          {
            "corregimiento": "CHEPO (CABECERA)",
            "codigo": "8-5-1"
          },
          {
            "corregimiento": "CAÑITA",
            "codigo": "8-5-2"
          },
          {
            "corregimiento": "CHEPILLO",
            "codigo": "8-5-3"
          },
          {
            "corregimiento": "EL LLANO",
            "codigo": "8-5-4"
          },
          {
            "corregimiento": "LAS MARGARITAS",
            "codigo": "8-5-5"
          },
          {
            "corregimiento": "SANTA CRUZ DE CHININA",
            "codigo": "8-5-6"
          },
          {
            "corregimiento": "COMARCA KUNA DE MADUNGANDI",
            "codigo": "8-5-7"
          },
          {
            "corregimiento": "TORTI",
            "codigo": "8-5-8"
          }
        ]
      },
      {
        "distrito": "CHIMAN",
        "codigo": "8-6",
        "corregimientos": [
          {
            "corregimiento": "CHIMAN (CABECERA)",
            "codigo": "8-6-1"
          },
          {
            "corregimiento": "BRUJAS",
            "codigo": "8-6-2"
          },
          {
            "corregimiento": "GONZALO VASQUEZ",
            "codigo": "8-6-3"
          },
          {
            "corregimiento": "PASIGA",
            "codigo": "8-6-4"
          },
          {
            "corregimiento": "UNION SANTEÑA",
            "codigo": "8-6-5"
          }
        ]
      },
      {
        "distrito": "PANAMA",
        "codigo": "8-8",
        "corregimientos": [
          {
            "corregimiento": "SAN FELIPE",
            "codigo": "8-8-1"
          },
          {
            "corregimiento": "EL CHORRILLO",
            "codigo": "8-8-2"
          },
          {
            "corregimiento": "SANTA ANA",
            "codigo": "8-8-3"
          },
          {
            "corregimiento": "LA EXPOSICION O CALIDONIA",
            "codigo": "8-8-4"
          },
          {
            "corregimiento": "CURUNDU",
            "codigo": "8-8-5"
          },
          {
            "corregimiento": "BETANIA",
            "codigo": "8-8-6"
          },
          {
            "corregimiento": "BELLA VISTA",
            "codigo": "8-8-7"
          },
          {
            "corregimiento": "PUEBLO NUEVO",
            "codigo": "8-8-8"
          },
          {
            "corregimiento": "SAN FRANCISCO",
            "codigo": "8-8-9"
          },
          {
            "corregimiento": "PARQUE LEFEVRE",
            "codigo": "8-8-10"
          },
          {
            "corregimiento": "RIO ABAJO",
            "codigo": "8-8-11"
          },
          {
            "corregimiento": "JUAN DIAZ",
            "codigo": "8-8-12"
          },
          {
            "corregimiento": "PEDREGAL",
            "codigo": "8-8-13"
          },
          {
            "corregimiento": "ANCON",
            "codigo": "8-8-14"
          },
          {
            "corregimiento": "CHILIBRE",
            "codigo": "8-8-15"
          },
          {
            "corregimiento": "LAS CUMBRES",
            "codigo": "8-8-16"
          },
          {
            "corregimiento": "PACORA",
            "codigo": "8-8-17"
          },
          {
            "corregimiento": "SAN MARTIN",
            "codigo": "8-8-18"
          },
          {
            "corregimiento": "TOCUMEN",
            "codigo": "8-8-19"
          },
          {
            "corregimiento": "LAS MAQANITAS",
            "codigo": "8-8-20"
          },
          {
            "corregimiento": "24 DE DICIEMBRE",
            "codigo": "8-8-21"
          },
          {
            "corregimiento": "ERNESTO CORDOBA CAMPOS",
            "codigo": "8-8-22"
          },
          {
            "corregimiento": "ALCALDE DIAZ",
            "codigo": "8-8-23"
          },
          {
            "corregimiento": "CAIMITILLO",
            "codigo": "8-8-24"
          },
          {
            "corregimiento": "DON BOSCO",
            "codigo": "8-8-25"
          },
          {
            "corregimiento": "LAS GARZAS",
            "codigo": "8-8-26"
          }
        ]
      },
      {
        "distrito": "SAN MIGUELITO",
        "codigo": "8-10",
        "corregimientos": [
          {
            "corregimiento": "AMELIA DENIS DE ICAZA",
            "codigo": "8-10-1"
          },
          {
            "corregimiento": "BELISARIO PORRAS",
            "codigo": "8-10-2"
          },
          {
            "corregimiento": "JOSE DOMINGO ESPINAR",
            "codigo": "8-10-3"
          },
          {
            "corregimiento": "MATEO ITURRALDE",
            "codigo": "8-10-4"
          },
          {
            "corregimiento": "VICTORIANO LORENZO",
            "codigo": "8-10-5"
          },
          {
            "corregimiento": "ARNULFO ARIAS",
            "codigo": "8-10-6"
          },
          {
            "corregimiento": "BELISARIO FRIAS",
            "codigo": "8-10-7"
          },
          {
            "corregimiento": "OMAR TORRIJOS",
            "codigo": "8-10-8"
          },
          {
            "corregimiento": "RUFINA ALFARO",
            "codigo": "8-10-9"
          }
        ]
      },
      {
        "distrito": "TABOGA",
        "codigo": "8-11",
        "corregimientos": [
          {
            "corregimiento": "TABOGA (CABECERA)",
            "codigo": "8-11-1"
          },
          {
            "corregimiento": "OTOQUE ORIENTE",
            "codigo": "8-11-2"
          },
          {
            "corregimiento": "OTOQUE OCCIDENTE",
            "codigo": "8-11-3"
          }
        ]
      }
    ]
  },
  {
    "provincia": "VERAGUAS",
    "codigo": "9",
    "distritos": [
      {
        "distrito": "ATALAYA",
        "codigo": "9-1",
        "corregimientos": [
          {
            "corregimiento": "ATALAYA (CABECERA)",
            "codigo": "9-1-1"
          },
          {
            "corregimiento": "EL BARRITO",
            "codigo": "9-1-2"
          },
          {
            "corregimiento": "LA MONTAÑUELA",
            "codigo": "9-1-3"
          },
          {
            "corregimiento": "LA CARRILLO",
            "codigo": "9-1-4"
          },
          {
            "corregimiento": "SAN ANTONIO",
            "codigo": "9-1-5"
          }
        ]
      },
      {
        "distrito": "CALOBRE",
        "codigo": "9-2",
        "corregimientos": [
          {
            "corregimiento": "CALOBRE (CABECERA)",
            "codigo": "9-2-1"
          },
          {
            "corregimiento": "BARNIZAL",
            "codigo": "9-2-2"
          },
          {
            "corregimiento": "CHITRA",
            "codigo": "9-2-3"
          },
          {
            "corregimiento": "EL COCLA",
            "codigo": "9-2-4"
          },
          {
            "corregimiento": "EL POTRERO",
            "codigo": "9-2-5"
          },
          {
            "corregimiento": "LA LAGUNA",
            "codigo": "9-2-6"
          },
          {
            "corregimiento": "LA RAYA DE CALOBRE",
            "codigo": "9-2-7"
          },
          {
            "corregimiento": "LA TETILLA",
            "codigo": "9-2-8"
          },
          {
            "corregimiento": "LA YEGUADA",
            "codigo": "9-2-9"
          },
          {
            "corregimiento": "LAS GUIAS",
            "codigo": "9-2-10"
          },
          {
            "corregimiento": "MONJARAS",
            "codigo": "9-2-11"
          },
          {
            "corregimiento": "SAN JOSE",
            "codigo": "9-2-12"
          }
        ]
      },
      {
        "distrito": "CAÑAZAS",
        "codigo": "9-3",
        "corregimientos": [
          {
            "corregimiento": "CAÑAZAS (CABECERA)",
            "codigo": "9-3-1"
          },
          {
            "corregimiento": "CERRO PLATA",
            "codigo": "9-3-2"
          },
          {
            "corregimiento": "EL PICADOR",
            "codigo": "9-3-3"
          },
          {
            "corregimiento": "LOS VALLES",
            "codigo": "9-3-4"
          },
          {
            "corregimiento": "SAN JOSE",
            "codigo": "9-3-5"
          },
          {
            "corregimiento": "SAN MARCELO",
            "codigo": "9-3-6"
          },
          {
            "corregimiento": "EL AROMILLO",
            "codigo": "9-3-7"
          }
        ]
      },
      {
        "distrito": "LA MEZA",
        "codigo": "9-4",
        "corregimientos": [
          {
            "corregimiento": "LA MESA (CABECERA)",
            "codigo": "9-4-1"
          },
          {
            "corregimiento": "BISVALLES",
            "codigo": "9-4-2"
          },
          {
            "corregimiento": "BORO",
            "codigo": "9-4-3"
          },
          {
            "corregimiento": "LLANO GRANDE",
            "codigo": "9-4-4"
          },
          {
            "corregimiento": "SAN BARTOLO",
            "codigo": "9-4-5"
          },
          {
            "corregimiento": "LOS MILAGROS",
            "codigo": "9-4-6"
          }
        ]
      },
      {
        "distrito": "LAS PALMAS",
        "codigo": "9-5",
        "corregimientos": [
          {
            "corregimiento": "LAS PALMAS (CABECERA)",
            "codigo": "9-5-1"
          },
          {
            "corregimiento": "CERRO DE CASA",
            "codigo": "9-5-2"
          },
          {
            "corregimiento": "COROZAL",
            "codigo": "9-5-3"
          },
          {
            "corregimiento": "EL MARIA",
            "codigo": "9-5-4"
          },
          {
            "corregimiento": "EL PRADO",
            "codigo": "9-5-5"
          },
          {
            "corregimiento": "EL RINCON",
            "codigo": "9-5-6"
          },
          {
            "corregimiento": "LOLA",
            "codigo": "9-5-7"
          },
          {
            "corregimiento": "PIXVAE",
            "codigo": "9-5-8"
          },
          {
            "corregimiento": "PUERTO VIDAL",
            "codigo": "9-5-9"
          },
          {
            "corregimiento": "SAN MARTIN DE PORRES",
            "codigo": "9-5-10"
          },
          {
            "corregimiento": "VIGUI",
            "codigo": "9-5-11"
          },
          {
            "corregimiento": "ZAPOTILLO",
            "codigo": "9-5-12"
          }
        ]
      },
      {
        "distrito": "MONTIJO",
        "codigo": "9-6",
        "corregimientos": [
          {
            "corregimiento": "MONTIJO (CABECERA)",
            "codigo": "9-6-1"
          },
          {
            "corregimiento": "ARENAS",
            "codigo": "9-6-2"
          },
          {
            "corregimiento": "GOBERNADORA",
            "codigo": "9-6-3"
          },
          {
            "corregimiento": "LA GARCEANA",
            "codigo": "9-6-4"
          },
          {
            "corregimiento": "LEONES",
            "codigo": "9-6-5"
          },
          {
            "corregimiento": "CEBACO",
            "codigo": "9-6-6"
          },
          {
            "corregimiento": "COSTA HERMOSA",
            "codigo": "9-6-7"
          },
          {
            "corregimiento": "UNION DEL NORTE",
            "codigo": "9-6-8"
          },
          {
            "corregimiento": "TEBARIO",
            "codigo": "9-6-9"
          },
          {
            "corregimiento": "EL PILON",
            "codigo": "9-6-10"
          }
        ]
      },
      {
        "distrito": "RIO DE JESUS",
        "codigo": "9-7",
        "corregimientos": [
          {
            "corregimiento": "RIO DE JESUS (CABECERA)",
            "codigo": "9-7-1"
          },
          {
            "corregimiento": "LAS HUACAS",
            "codigo": "9-7-2"
          },
          {
            "corregimiento": "LOS CASTILLOS",
            "codigo": "9-7-3"
          },
          {
            "corregimiento": "UTIRA",
            "codigo": "9-7-4"
          },
          {
            "corregimiento": "CATORCE DE NOVIEMBRE",
            "codigo": "9-7-5"
          }
        ]
      },
      {
        "distrito": "SAN FRANCISCO",
        "codigo": "9-8",
        "corregimientos": [
          {
            "corregimiento": "SAN FRANCISCO (CABECERA)",
            "codigo": "9-8-1"
          },
          {
            "corregimiento": "CORRAL FALSO",
            "codigo": "9-8-2"
          },
          {
            "corregimiento": "LOS HATILLOS",
            "codigo": "9-8-3"
          },
          {
            "corregimiento": "REMANCE",
            "codigo": "9-8-4"
          },
          {
            "corregimiento": "SAN JUAN",
            "codigo": "9-8-5"
          },
          {
            "corregimiento": "SAN JOSE",
            "codigo": "9-8-6"
          }
        ]
      },
      {
        "distrito": "SANTA FE",
        "codigo": "9-9",
        "corregimientos": [
          {
            "corregimiento": "SANTA FE (CABECERA)",
            "codigo": "9-9-1"
          },
          {
            "corregimiento": "CALOVEBORA",
            "codigo": "9-9-2"
          },
          {
            "corregimiento": "EL ALTO",
            "codigo": "9-9-3"
          },
          {
            "corregimiento": "EL CUAY",
            "codigo": "9-9-4"
          },
          {
            "corregimiento": "EL PANTANO",
            "codigo": "9-9-5"
          },
          {
            "corregimiento": "GATU O GATUCITO",
            "codigo": "9-9-6"
          },
          {
            "corregimiento": "RIO LUIS",
            "codigo": "9-9-7"
          }
        ]
      },
      {
        "distrito": "SANTIAGO",
        "codigo": "9-10",
        "corregimientos": [
          {
            "corregimiento": "SANTIAGO (CABECERA)",
            "codigo": "9-10-1"
          },
          {
            "corregimiento": "LA COLORADA",
            "codigo": "9-10-2"
          },
          {
            "corregimiento": "LA PEÑA",
            "codigo": "9-10-3"
          },
          {
            "corregimiento": "LA RAYA DE SANTA MARIA",
            "codigo": "9-10-4"
          },
          {
            "corregimiento": "PONUGA",
            "codigo": "9-10-5"
          },
          {
            "corregimiento": "SAN PEDRO DEL ESPINO",
            "codigo": "9-10-6"
          },
          {
            "corregimiento": "CANTO DEL LLANO",
            "codigo": "9-10-7"
          },
          {
            "corregimiento": "LOS ALGARROBOS",
            "codigo": "9-10-8"
          },
          {
            "corregimiento": "CARLOS SANTANA AVILA",
            "codigo": "9-10-9"
          },
          {
            "corregimiento": "EDWIN FABREGA",
            "codigo": "9-10-10"
          },
          {
            "corregimiento": "SAN MARTIN DE PORRES",
            "codigo": "9-10-11"
          },
          {
            "corregimiento": "URRACA",
            "codigo": "9-10-12"
          }
        ]
      },
      {
        "distrito": "SONA",
        "codigo": "9-11",
        "corregimientos": [
          {
            "corregimiento": "SONA (CABECERA)",
            "codigo": "9-11-1"
          },
          {
            "corregimiento": "BAHIA HONDA",
            "codigo": "9-11-2"
          },
          {
            "corregimiento": "CALIDONIA",
            "codigo": "9-11-3"
          },
          {
            "corregimiento": "CATIVE",
            "codigo": "9-11-4"
          },
          {
            "corregimiento": "EL MARAÑON",
            "codigo": "9-11-5"
          },
          {
            "corregimiento": "GUARUMAL",
            "codigo": "9-11-6"
          },
          {
            "corregimiento": "LA SOLEDAD",
            "codigo": "9-11-7"
          },
          {
            "corregimiento": "QUEBRADA DE ORO",
            "codigo": "9-11-8"
          },
          {
            "corregimiento": "RIO GRANDE",
            "codigo": "9-11-9"
          },
          {
            "corregimiento": "RODEO VIEJO",
            "codigo": "9-11-10"
          }
        ]
      },
      {
        "distrito": "MARIATO",
        "codigo": "9-12",
        "corregimientos": [
          {
            "corregimiento": "LLANO DE CATIVAL O MARIATO (CABECERA)",
            "codigo": "9-12-1"
          },
          {
            "corregimiento": "ARENAS",
            "codigo": "9-12-2"
          },
          {
            "corregimiento": "EL CACAO",
            "codigo": "9-12-3"
          },
          {
            "corregimiento": "QUEBRO",
            "codigo": "9-12-4"
          },
          {
            "corregimiento": "TEBARIO",
            "codigo": "9-12-5"
          }
        ]
      }
    ]
  },
  {
    "provincia": "COMARCA KUNA YALA",
    "codigo": "10",
    "distritos": [
      {
        "distrito": "COMARCA KUNA YALA",
        "codigo": "10-1",
        "corregimientos": [
          {
            "corregimiento": "NARGANA (CABECERA)",
            "codigo": "10-1-1"
          },
          {
            "corregimiento": "AILIGANDI",
            "codigo": "10-1-2"
          },
          {
            "corregimiento": "PUERTO OBALDIA",
            "codigo": "10-1-3"
          },
          {
            "corregimiento": "TUBUALA",
            "codigo": "10-1-4"
          }
        ]
      }
    ]
  },
  {
    "provincia": "COMARCA EMBERA-WOUNAAN",
    "codigo": "11",
    "distritos": [
      {
        "distrito": "CEMACO",
        "codigo": "11-1",
        "corregimientos": [
          {
            "corregimiento": "CIRILO GUAINORA (CABECERA)",
            "codigo": "11-1-1"
          },
          {
            "corregimiento": "LAJAS BLANCAS",
            "codigo": "11-1-2"
          },
          {
            "corregimiento": "MANUEL ORTEGA",
            "codigo": "11-1-3"
          }
        ]
      },
      {
        "distrito": "SAMBU",
        "codigo": "11-2",
        "corregimientos": [
          {
            "corregimiento": "RIO SABALO",
            "codigo": "11-2-1"
          },
          {
            "corregimiento": "JINGURUDO",
            "codigo": "11-2-2"
          }
        ]
      }
    ]
  },
  {
    "provincia": "COMARCA NGÄBE-BUGLÉ",
    "codigo": "12",
    "distritos": [
      {
        "distrito": "BESIKO",
        "codigo": "12-1",
        "corregimientos": [
          {
            "corregimiento": "SOLOY (CABECERA)",
            "codigo": "12-1-1"
          },
          {
            "corregimiento": "BOCA DE BALSA",
            "codigo": "12-1-2"
          },
          {
            "corregimiento": "CAMARON ARRIBA",
            "codigo": "12-1-3"
          },
          {
            "corregimiento": "CERRO BANCO",
            "codigo": "12-1-4"
          },
          {
            "corregimiento": "CERRO DE PATENA",
            "codigo": "12-1-5"
          },
          {
            "corregimiento": "EMPLANADA DE CHORCHA",
            "codigo": "12-1-6"
          },
          {
            "corregimiento": "NAMNONI",
            "codigo": "12-1-7"
          },
          {
            "corregimiento": "NIBA",
            "codigo": "12-1-8"
          }
        ]
      },
      {
        "distrito": "MIRONO",
        "codigo": "12-2",
        "corregimientos": [
          {
            "corregimiento": "HATO PILON (CABECERA)",
            "codigo": "12-2-1"
          },
          {
            "corregimiento": "CASCABEL",
            "codigo": "12-2-2"
          },
          {
            "corregimiento": "HATO COROTU",
            "codigo": "12-2-3"
          },
          {
            "corregimiento": "HATO CULANTRO",
            "codigo": "12-2-4"
          },
          {
            "corregimiento": "HATO JOBO",
            "codigo": "12-2-5"
          },
          {
            "corregimiento": "HATO JULI",
            "codigo": "12-2-6"
          },
          {
            "corregimiento": "QUEBRADA DE LORO",
            "codigo": "12-2-7"
          },
          {
            "corregimiento": "SALTO DUPI",
            "codigo": "12-2-8"
          }
        ]
      },
      {
        "distrito": "MUNA",
        "codigo": "12-3",
        "corregimientos": [
          {
            "corregimiento": "CHICHICA (CABECERA)",
            "codigo": "12-3-1"
          },
          {
            "corregimiento": "ALTO CABALLERO",
            "codigo": "12-3-2"
          },
          {
            "corregimiento": "BAKAMA",
            "codigo": "12-3-3"
          },
          {
            "corregimiento": "CERRO CAÑA",
            "codigo": "12-3-4"
          },
          {
            "corregimiento": "CERRO PUERCO",
            "codigo": "12-3-5"
          },
          {
            "corregimiento": "KRUA",
            "codigo": "12-3-6"
          },
          {
            "corregimiento": "MARACA",
            "codigo": "12-3-7"
          },
          {
            "corregimiento": "NIBRA",
            "codigo": "12-3-8"
          },
          {
            "corregimiento": "PEÑA BLANCA",
            "codigo": "12-3-9"
          },
          {
            "corregimiento": "ROKA",
            "codigo": "12-3-10"
          },
          {
            "corregimiento": "SITIO PRADO",
            "codigo": "12-3-11"
          },
          {
            "corregimiento": "UMANI",
            "codigo": "12-3-12"
          }
        ]
      },
      {
        "distrito": "NOLE DUIMA",
        "codigo": "12-4",
        "corregimientos": [
          {
            "corregimiento": "CERRO IGLESIAS (CABECERA)",
            "codigo": "12-4-1"
          },
          {
            "corregimiento": "HATO CHAMI",
            "codigo": "12-4-2"
          },
          {
            "corregimiento": "JADEBERI",
            "codigo": "12-4-3"
          },
          {
            "corregimiento": "LAJERO",
            "codigo": "12-4-4"
          },
          {
            "corregimiento": "SUSAMA",
            "codigo": "12-4-5"
          }
        ]
      },
      {
        "distrito": "NURUM",
        "codigo": "12-5",
        "corregimientos": [
          {
            "corregimiento": "BUENOS AIRES (CABECERA)",
            "codigo": "12-5-1"
          },
          {
            "corregimiento": "AGUA DE SALUD",
            "codigo": "12-5-2"
          },
          {
            "corregimiento": "ALTO DE JESUS",
            "codigo": "12-5-3"
          },
          {
            "corregimiento": "CERRO PELADO",
            "codigo": "12-5-4"
          },
          {
            "corregimiento": "EL BALE",
            "codigo": "12-5-5"
          },
          {
            "corregimiento": "EL PAREDON",
            "codigo": "12-5-6"
          },
          {
            "corregimiento": "EL PIRO",
            "codigo": "12-5-7"
          },
          {
            "corregimiento": "GUAYABITO",
            "codigo": "12-5-8"
          },
          {
            "corregimiento": "GUIBALE",
            "codigo": "12-5-9"
          }
        ]
      },
      {
        "distrito": "KANKINTU",
        "codigo": "12-6",
        "corregimientos": [
          {
            "corregimiento": "BISIRA (CABECERA)",
            "codigo": "12-6-1"
          },
          {
            "corregimiento": "BURI",
            "codigo": "12-6-2"
          },
          {
            "corregimiento": "GUARIVIARA",
            "codigo": "12-6-3"
          },
          {
            "corregimiento": "GUORONI",
            "codigo": "12-6-4"
          },
          {
            "corregimiento": "KANKINTU",
            "codigo": "12-6-5"
          },
          {
            "corregimiento": "MUNUNI",
            "codigo": "12-6-6"
          },
          {
            "corregimiento": "PIEDRA ROJA",
            "codigo": "12-6-7"
          },
          {
            "corregimiento": "TUWAI",
            "codigo": "12-6-8"
          },
          {
            "corregimiento": "MAN CREEK",
            "codigo": "12-6-9"
          }
        ]
      },
      {
        "distrito": "KUSAPIN",
        "codigo": "12-7",
        "corregimientos": [
          {
            "corregimiento": "KUSAPIN (CABECERA)",
            "codigo": "12-7-1"
          },
          {
            "corregimiento": "BAHIA AZUL",
            "codigo": "12-7-2"
          },
          {
            "corregimiento": "CALOVEBORA O SANTA CATALINA",
            "codigo": "12-7-3"
          },
          {
            "corregimiento": "LOMA YUCA",
            "codigo": "12-7-4"
          },
          {
            "corregimiento": "RIO CHIRIQUI",
            "codigo": "12-7-5"
          },
          {
            "corregimiento": "TOBOBE",
            "codigo": "12-7-6"
          },
          {
            "corregimiento": "VALLE BONITO",
            "codigo": "12-7-7"
          }
        ]
      }
    ]
  },
  {
    "provincia": "PANAMA OESTE",
    "codigo": "13",
    "distritos": [
      {
        "distrito": "ARRAIJAN",
        "codigo": "13-1",
        "corregimientos": [
          {
            "corregimiento": "ARRAIJAN (CABECERA)",
            "codigo": "13-1-1"
          },
          {
            "corregimiento": "BURUNGA",
            "codigo": "13-1-2"
          },
          {
            "corregimiento": "CERRO SILVESTRE",
            "codigo": "13-1-3"
          },
          {
            "corregimiento": "JUAN DEMOSTENES AROSEMENA",
            "codigo": "13-1-4"
          },
          {
            "corregimiento": "NUEVO EMPERADOR",
            "codigo": "13-1-5"
          },
          {
            "corregimiento": "SANTA CLARA",
            "codigo": "13-1-6"
          },
          {
            "corregimiento": "VERACRUZ",
            "codigo": "13-1-7"
          },
          {
            "corregimiento": "VISTA ALEGRE",
            "codigo": "13-1-8"
          }
        ]
      },
      {
        "distrito": "CAPIRA",
        "codigo": "13-2",
        "corregimientos": [
          {
            "corregimiento": "CAPIRA (CABECERA)",
            "codigo": "13-2-1"
          },
          {
            "corregimiento": "CAIMITO",
            "codigo": "13-2-2"
          },
          {
            "corregimiento": "CAMPANA",
            "codigo": "13-2-3"
          },
          {
            "corregimiento": "CERMEÑO",
            "codigo": "13-2-4"
          },
          {
            "corregimiento": "CIRI DE LOS SOTOS",
            "codigo": "13-2-5"
          },
          {
            "corregimiento": "CIRI GRANDE",
            "codigo": "13-2-6"
          },
          {
            "corregimiento": "EL CACAO",
            "codigo": "13-2-7"
          },
          {
            "corregimiento": "LA TRINIDAD",
            "codigo": "13-2-8"
          },
          {
            "corregimiento": "LAS OLLAS ARRIBA",
            "codigo": "13-2-9"
          },
          {
            "corregimiento": "LIDICE",
            "codigo": "13-2-10"
          },
          {
            "corregimiento": "VILLA CARMEN",
            "codigo": "13-2-11"
          },
          {
            "corregimiento": "VILLA ROSARIO",
            "codigo": "13-2-12"
          },
          {
            "corregimiento": "SANTA ROSA",
            "codigo": "13-2-13"
          }
        ]
      },
      {
        "distrito": "CHAME",
        "codigo": "13-3",
        "corregimientos": [
          {
            "corregimiento": "CHAME (CABECERA)",
            "codigo": "13-3-1"
          },
          {
            "corregimiento": "BEJUCO",
            "codigo": "13-3-2"
          },
          {
            "corregimiento": "BUENOS AIRES",
            "codigo": "13-3-3"
          },
          {
            "corregimiento": "CABUYA",
            "codigo": "13-3-4"
          },
          {
            "corregimiento": "CHICA",
            "codigo": "13-3-5"
          },
          {
            "corregimiento": "EL LIBANO",
            "codigo": "13-3-6"
          },
          {
            "corregimiento": "LAS LAJAS",
            "codigo": "13-3-7"
          },
          {
            "corregimiento": "NUEVA GORGONA",
            "codigo": "13-3-8"
          },
          {
            "corregimiento": "PUNTA CHAME",
            "codigo": "13-3-9"
          },
          {
            "corregimiento": "SAJALICES",
            "codigo": "13-3-10"
          },
          {
            "corregimiento": "SORA",
            "codigo": "13-3-11"
          }
        ]
      },
      {
        "distrito": "LA CHORRERA",
        "codigo": "13-4",
        "corregimientos": [
          {
            "corregimiento": "BARRIO BALBOA",
            "codigo": "13-4-1"
          },
          {
            "corregimiento": "BARRIO COLON",
            "codigo": "13-4-2"
          },
          {
            "corregimiento": "AMADOR",
            "codigo": "13-4-3"
          },
          {
            "corregimiento": "AROSEMENA",
            "codigo": "13-4-4"
          },
          {
            "corregimiento": "EL ARADO",
            "codigo": "13-4-5"
          },
          {
            "corregimiento": "EL COCO",
            "codigo": "13-4-6"
          },
          {
            "corregimiento": "FEUILLET",
            "codigo": "13-4-7"
          },
          {
            "corregimiento": "GUADALUPE",
            "codigo": "13-4-8"
          },
          {
            "corregimiento": "HERRERA",
            "codigo": "13-4-9"
          },
          {
            "corregimiento": "HURTADO",
            "codigo": "13-4-10"
          },
          {
            "corregimiento": "ITURRALDE",
            "codigo": "13-4-11"
          },
          {
            "corregimiento": "LA REPRESA",
            "codigo": "13-4-12"
          },
          {
            "corregimiento": "LOS DIAZ",
            "codigo": "13-4-13"
          },
          {
            "corregimiento": "MENDOZA",
            "codigo": "13-4-14"
          },
          {
            "corregimiento": "OBALDIA",
            "codigo": "13-4-15"
          },
          {
            "corregimiento": "PLAYA LEONA",
            "codigo": "13-4-16"
          },
          {
            "corregimiento": "PUERTO CAIMITO",
            "codigo": "13-4-17"
          },
          {
            "corregimiento": "SANTA RITA",
            "codigo": "13-4-18"
          }
        ]
      },
      {
        "distrito": "SAN CARLOS",
        "codigo": "13-5",
        "corregimientos": [
          {
            "corregimiento": "SAN CARLOS (CABECERA)",
            "codigo": "13-5-1"
          },
          {
            "corregimiento": "EL ESPINO",
            "codigo": "13-5-2"
          },
          {
            "corregimiento": "EL HIGO",
            "codigo": "13-5-3"
          },
          {
            "corregimiento": "GUAYABITO",
            "codigo": "13-5-4"
          },
          {
            "corregimiento": "LA ERMITA",
            "codigo": "13-5-5"
          },
          {
            "corregimiento": "LA LAGUNA",
            "codigo": "13-5-6"
          },
          {
            "corregimiento": "LAS UVAS",
            "codigo": "13-5-7"
          },
          {
            "corregimiento": "LOS LLANITOS",
            "codigo": "13-5-8"
          },
          {
            "corregimiento": "SAN JOSE",
            "codigo": "13-5-9"
          }
        ]
      }
    ]
  }
]
